export default function round(number, precision) {
  var factor = Math.pow(10, precision);
  return Math.round(number * factor) / factor;
}



// WEBPACK FOOTER //
// ./src/js/round.js